// AI Generated Component
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UserRepoService } from '@client/app/services/api/user-repo/user-repo.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { FormUserComponent } from '@client/app/forms/user/user.component';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'admin-users',
    templateUrl: './users.component.html',
    standalone: false,
})
export class UsersComponent extends BaseContainerComponentController implements OnInit {
    users: any = [];
    selectedRoles: any = [];
    subheaderTranslation: string = '';
    override currentSort: any = {
        by: 'first_name',
        direction: 'desc',
    };
    exports: any = [];
    promise: any = new Promise(resolve => {});

    constructor (
        private userRepoService: UserRepoService,
        private monEventService: MonEventService,
        private translateService: TranslateService,
        private cdRef: ChangeDetectorRef,
    ) {
        super({ table: true, filters: true, labels: true });
    }

    ngOnInit (): void {
        this.init();
    }

    async init (): Promise<void> {
        this.users = [];
        this.search = null;
        this.selectedRoles = [];
        this.filters.roles = [];
        this.subheaderTranslation = '';
        this.availableFilters.roles = [
            {
                id: true,
                name: 'Admin',
            },
            {
                id: false,
                name: 'Normal',
            },
        ];
        this.currentSort = {
            by: 'first_name',
            direction: 'desc',
        };
        this.exports = [
            {
                name: 'User Export',
                data: {
                    category: 'users_with_domain_access',
                },
            },
        ];
        await this.getLabels();
        this.getPage();
        this.getSubHeaderDescription();
    }

    override getPage = (): void => {
        const params: any = {
            page: this.page,
            page_size: this.pageSize,
            search: this.search || null,
            sort_by: this.currentSort.by,
            sort_dir: this.currentSort.direction,
        };
        if (this.selectedLabels && this.selectedLabels.length > 0) {
            params['labels[]'] = this.selectedLabels;
        }
        if (this.selectedRoles.length > 0) {
            params.admin = this.selectedRoles[0].id;
        }
        this.promise = this.userRepoService.getAll(params).then((data: any) => {
            this.users = data;
            this.getSubHeaderDescription();
        });
    };

    addUser (user?: any): void {
        user = user || {};
        const params = {
            body: FormUserComponent,
            size: 'md',
            data: { user: user },
        };
        const callback = (userResult: any) => {
            if (userResult) {
                this.getPage();
            }
        };
        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params, callback });
    }

    getSubHeaderDescription (): void {
        this.subheaderTranslation = this.translateService.getPlural(
            this.users.total,
            'You have 1 user on your account',
            'You have [[$count]] users on your account',
            {},
            'count',
        );
    }

    onFiltersChanges (changes: any): void {
        this.updateFilters(changes);
        if (changes.changes) {
            changes = changes.changes;
        }
        if (changes.roles.length === 1) {
            this.selectedRoles = changes.roles;
        } else if (changes.roles.length > 1) {
            this.selectedRoles.splice(0, 1);
        } else {
            this.selectedRoles = [];
        }
        this.getPage();
    }
}
